module.exports = __webpack_public_path__ + "static/gallery-f4f1b60bd52e4e833d87fd628fcb4f30.png";